import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { Stack } from "types/generated";
import useEnableStack from "shared/Stack/useEnableStack";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";

type EnableButtonProps = {
  stackId: Stack["id"];
  disabled?: boolean;
  tooltip?: string;
};

const EnableButton = ({ stackId, disabled, tooltip }: EnableButtonProps) => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [enableStack, { loading }] = useEnableStack({
    refetchQueries: ["GetStack"],
  });

  const handleClick = () =>
    enableStack({ id: stackId }, (data) => {
      if (data?.stackEnable.id) {
        reportSuccess({ message: "Stack successfully enabled" });
      }
    });

  return (
    <DropdownMenuItem
      onAction={handleClick}
      isDisabled={disabled || loading}
      loading={loading}
      tooltip={tooltip}
    >
      Enable
    </DropdownMenuItem>
  );
};

export default EnableButton;
